import React from 'react'
import ModalFormUI from './../../../widgets/form/ModalFormUI'
import InputTextSF from './../../../widgets/form/InputTextSF'
import InputSelectSF from '../../../widgets/form/InputSelectSF'

const VendorPanCreateModalUI = ({
    context, messageList, successMsg, errorList,
    createMode, submitted, onSubmit, onCancelClick, setErrorList,
    //
    vendorName, onVendorNameChange, vendorNameError, setVendorNameError,
    //
    ifscCode, onIfscCodeChange, ifscCodeError, setIfscCodeError,
    //
    bankAccountNumber, onBankAccountNumberChange, bankAccountNumberError, setBankAccountNumberError,
    //
    beneficiaryName, onBeneficiaryNameChange, beneficiaryNameError, setBeneficiaryNameError,
    //
    tdsCode, onTdsCodeChange, tdsList, tdsCodeError, setTdsCodeError,
    //
    state, onStateChange, stateList, stateError, setStateError,
    //
    gstin, onGstinChange, gstinError, setGstinError, gstinList,
    //
    panNumber, onPanNumberChange, panNumberError, setPanNumberError,
}) =>
    <ModalFormUI
        context={context}
        messageList={messageList}
        titleLabel='Add vendor with PAN'
        buttonLabel='Add'
        cancelLabel='Cancel'
        isOpen={createMode}
        onRequestClose={onCancelClick}
        successMsg={successMsg}
        setErrorList={setErrorList}
        errorList={errorList}
        onSubmit={onSubmit}
        busy={submitted}
    >
        <div className='g_flex_h g_flex_top c_ln_crt'>
            <div className='col'>
                <InputTextSF type='text' name='panNumber' label='Pan Number'
                    required={true}
                    value={panNumber} onChange={onPanNumberChange}
                    error={panNumberError} setError={setPanNumberError}
                />
                {
                    gstinList && gstinList.length > 0 &&
                    <InputSelectSF type='text' name='gstin' label='GST'
                        required={true}
                        value={gstin} onChange={onGstinChange} optionList={gstinList}
                        error={gstinError} setError={setGstinError}
                    />
                }
                {
                    gstinList && gstinList.length === 0 &&
                    <InputSelectSF type='select' name='state' label='State'
                        required={true}
                        value={state} onChange={onStateChange} optionList={stateList}
                        error={stateError} setError={setStateError}
                    />
                }
                {
                    gstinList &&
                    <InputSelectSF type='select' name='tdsCode' label='TDS'
                        required={true}
                        value={tdsCode} onChange={onTdsCodeChange} optionList={tdsList}
                        error={tdsCodeError} setError={setTdsCodeError}
                    />
                }
            </div>
            <div className='g_m_left_100'>
                {
                    gstinList &&
                    <>
                        <InputTextSF type='text' name='vendorName' label='Vendor name'
                            required={true}
                            value={vendorName} onChange={onVendorNameChange}
                            error={vendorNameError}
                            setError={setVendorNameError}
                            autoFocus={true}
                        />

                        <InputTextSF type='text' name='bankAccountNumber' label='Bank account number'
                            required={true}
                            value={bankAccountNumber} onChange={onBankAccountNumberChange}
                            error={bankAccountNumberError} setError={setBankAccountNumberError}
                        />

                        <InputTextSF type='text' name='ifscCode' label='IFSC code'
                            required={true}
                            value={ifscCode} onChange={onIfscCodeChange}
                            error={ifscCodeError} setError={setIfscCodeError}
                        />

                        <InputTextSF type='text' name='beneficiaryName' label='Beneficiary name'
                            required={true}
                            value={beneficiaryName} onChange={onBeneficiaryNameChange}
                            error={beneficiaryNameError} setError={setBeneficiaryNameError}
                        />
                    </>
                }
            </div>
        </div>

    </ModalFormUI>

export default VendorPanCreateModalUI;
